import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { CommonFunctions } from '../common-functions';
import { API_BASE_URL, ThumbApplicationType } from '../service-proxies';
import { Inject, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(private _commonFunctions: CommonFunctions, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  clockInOutInfo(month?: number, year?: number, header: any = {}): Observable<any> {
    const url = `${this.baseUrl}/api/ClockInOut/ClockInOutInfo`;
    let params = new HttpParams();

    if (month !== undefined) params = params.set('month', month.toString());
    if (year !== undefined) params = params.set('year', year.toString());

    return this.http.get(url, { headers: new HttpHeaders(header), params }).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }

  createClockInOrOutEntry(thumbType: ThumbApplicationType, header: any = {}) {
    const url = `${this.baseUrl}/api/ClockInOut/CreateClockInOrOutEntry/${thumbType}`;
    return this.http.get(url, header).pipe(
      catchError((error) => {
        console.error('API Error:', error);
        throw error;
      })
    );
  }

  generateQRForAttendance(header: any = {}) {
    const url = `${this.baseUrl}/api/ClockInOut/generateQRForAttendance`;
    return this.http.get(url, header).pipe(
      catchError((error) => {
        console.error('API Error:', error);
        throw error;
      })
    );
  }

}
